import { element } from 'protractor';
import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AuthService } from './services/auth/auth.service';
import { Router } from '@angular/router';
import { ApiService } from './services/api/api.service';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import Pusher from 'pusher-js';
import { pusherConfig } from 'src/environments/environment.prod';
import { RealtimeApiService } from 'src/app/services/realtimeApi/realtime-api.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent {
    account: any = false;
    flag: any = true
    audio: any;
    pusherClient: Pusher;

    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        private router: Router,
        public api: ApiService,
        private http: HttpClient,
        public auth: AuthService,
        public dataProvider: RealtimeApiService,
    ) {
        this.initializeApp();
        this.audio = new Audio();
        this.audio.src = 'assets/128.mp3';
        this.audio.load();
        this.initializePusher();
    }

    initializeApp() {
        this.api.getRef('orders').ref
            .where("status", "==", "pending")
            .where('countryCode', '==', this.auth.countryCode)
            .onSnapshot(snapshots => {
                // console.log(snapshots.size)

                snapshots.docChanges().forEach(element => {
                    console.log(element.type)
                    if (this.flag) {
                        this.flag = false
                    } else {
                        if (element.type == 'added') {
                            // console.log("nueva orden creada")
                            // console.log(element.doc.data())
                            // if (this.auth.countryCode == 'SV') {
                            //     this.http.get(`https://mails.barlleno.app/mails.php?mode=newOrder`)
                            //         .subscribe((response) => {
                            //         })
                            // } else if (this.auth.countryCode == 'GT') {
                            //     this.http.get(`https://mails.barlleno.app/gt/mails.php?mode=newOrder`)
                            //         .subscribe((response) => {
                            //         })
                            // } else if (this.auth.countryCode == 'DO') {
                            //     this.http.get(`https://mails.barlleno.app/do/mails.php?mode=newOrder`)
                            //         .subscribe((response) => {
                            //         })
                            // } else if (this.auth.countryCode == 'CO') {
                            //     this.http.get(`https://mails.barlleno.app/co/mails.php?mode=newOrder`)
                            //         .subscribe((response) => {
                            //         })
                            // } else if (this.auth.countryCode == 'HN') {
                            //     this.http.get(`https://mails.barlleno.app/hn/mails.php?mode=newOrder`)
                            //         .subscribe((response) => {
                            //         })
                            // }
                            Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: 'Nueva Orden Recibida - REFRESCA MONITOR',
                                showConfirmButton: false,
                                timer: 3000
                            }).then((result) => {
                                /* Read more about handling dismissals below */
                                if (result.dismiss === Swal.DismissReason.timer) {
                                    this.audio.play();
                                }
                            })
                        }
                    }
                });
            })
    }

    logout() {
        this.auth.logOut();
    }

    initializePusher() {
        this.pusherClient = new Pusher(pusherConfig.key, { cluster: pusherConfig.cluster });
        const channel = this.pusherClient.subscribe('chat-notifications');

        channel.bind(
            'posts',
            (data: { date: string; message: string; sender: string; type: string; conversationId: string }) => {
                let currentUser = localStorage.getItem("token") // esta variable es la que se debe cambiar dinamicamente
                // show only if sender is not current user
                if (data.sender != currentUser) {
                    // getting users of conversation
                    this.dataProvider.getUsersConversation(data.conversationId)
                        .then((users: Array<string>) => {
                            // show only if currentUser belongs to conversation
                            if (users.includes(currentUser)) {
                                Swal.fire(
                                    'Nuevo mensaje',
                                    data.message,
                                    'question'
                                )
                            }
                        })
                }
            }
        );
    }
}
